import React from 'react'
import GenesSearch from './GenesSearch'
import { ProductDetails, configContext } from '../Sirna'
import SearchResult from './SearchResult'
import SearchTable from './SearchTable'
import Paper from '@material-ui/core/Paper'
import { FormattedMessage } from 'react-intl'
import { makeStyles, Theme } from '@material-ui/core/styles'
import messages from '../../../messages'
import { useSemiConfSaveToSessionMutation } from '@src/mutations/SemiconfigSirnaMutation.generated'

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: theme.spacing(2),
    textAlign: 'justify',
  },
  errorMsgStyle: {
    textAlign: 'left',
    fontSize: theme.typography.pxToRem(16),
    borderRadius: theme.spacing(0),
    padding: theme.spacing(6, 0, 6, 2.5),
  },
}))

interface SelectAssaysProps {
  productDetails: ProductDetails
  currencyFormat: string
  thousandSeparator: any
  thousandSpacing: any
  prefixCurrecny: any
  decimalSeparator: any
}
const SelectAssays: React.FC<SelectAssaysProps> = (props) => {
  const { state } = React.useContext(configContext)
  const { searchResult, searchInput, checkboxUpdate, geneSearchError } = state
  const classes = useStyles()
  const {
    currencyFormat,
    thousandSeparator,
    thousandSpacing,
    prefixCurrecny,
    decimalSeparator,
    productDetails,
  } = props
  const [semiConfSaveToSession] = useSemiConfSaveToSessionMutation()
  React.useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  const saveSessionHandler = async (sessionData): Promise<void> => {
    await semiConfSaveToSession({
      variables: { input: sessionData, productInput: productDetails },
    })
  }

  return (
    <div>
      <GenesSearch
        productDetails={props.productDetails}
        saveSessionHandler={saveSessionHandler}
      />
      {searchResult.count !== 0 &&
      searchInput.term.length > 0 &&
      !geneSearchError ? (
        <div>
          <SearchResult />
          <SearchTable
            productDetails={props.productDetails}
            currencyFormat={currencyFormat}
            thousandSeparator={thousandSeparator}
            thousandSpacing={thousandSpacing}
            prefixCurrecny={prefixCurrecny}
            decimalSeparator={decimalSeparator}
          />
        </div>
      ) : searchResult.count === 0 &&
        searchInput.term.length > 0 &&
        checkboxUpdate &&
        !geneSearchError ? (
        <div>
          <SearchResult />
          <Paper className={classes.errorMsgStyle}>
            <div>
              <FormattedMessage
                {...messages.SEMICONF_NO_RECORDS_MSG_crisprgrna}
              />
            </div>
          </Paper>
        </div>
      ) : (
        ''
      )}
    </div>
  )
}

export default SelectAssays
